(() => {
  if (window.EBRangeCore) return;

  const clamp = (value, min, max) => Math.max(min, Math.min(max, value));
  const roundToFive = (value) => Math.round(Number(value || 0) / 5) * 5;

  window.EBRangeCore = {
    terrain: { mixed: 0.88, gravel: 0.7, offroad: 0.55, mountain: 0.5 },

    /* Fixed environment factors. Single source of truth — the Liquid template
       reads the same penalties so the -% badges and the live calculation never
       drift. value = multiplier applied to range. */
    environment: {
      cold:    { penalty: 20, icon: 'range',  factor: 0.80 },
      headwind:{ penalty: 15, icon: 'speed',  factor: 0.85 },
      cargo:   { penalty: 10, icon: 'weight', factor: 0.90 },
      stopgo:  { penalty: 12, icon: 'city',   factor: 0.88 },
    },

    /* Fallback multipliers used only when the assist-mode metaobject doesn't
       carry its own est_range / assist_percent. Keyed on handleized mode name. */
    modeRange:  { eco: 1.0, tour: 0.82, sport: 0.66, turbo: 0.55 },
    modeAssist: { eco: 35, tour: 55, sport: 80, turbo: 100 },

    /* Find the selected mode object on the model config. */
    findMode(config, modeId) {
      const modes = Array.isArray(config && config.modes) ? config.modes : [];
      const key = String(modeId || '').toLowerCase();
      return modes.find((m) => String(m.id || '').toLowerCase() === key) || modes[0] || null;
    },

    /* Rider-weight factor: 75 kg baseline (factor 1). Each kg away shifts range
       by 0.4% — heavier costs range, lighter gains a little. */
    weightFactor(weight) {
      const w = Number(weight || 75);
      return clamp(1 - (w - 75) * 0.004, 0.7, 1.12);
    },

    /* Base range for the selected mode. Prefer the metaobject's real est_range;
       otherwise fall back to bike max x handle multiplier. */
    modeBase(config, modeId) {
      const mode = this.findMode(config, modeId);
      const real = Number(mode && mode.range ? mode.range : 0);
      if (real > 0) return real;
      const max = Number((config && (config.max || config.modeFallback)) || 0);
      const key = String(modeId || '').toLowerCase();
      return max * (this.modeRange[key] != null ? this.modeRange[key] : 1);
    },

    estimate(base, factors) {
      let adjusted = Number(base || 0);
      (factors || []).forEach((f) => { adjusted *= Number(f || 1); });
      return {
        mid: adjusted,
        low: roundToFive(adjusted * 0.88),
        high: roundToFive(adjusted * 1.0),
      };
    },

    fill(range, max) {
      const basis = Number(max || 0);
      if (!basis) return 0;
      return clamp((Number(range && range.mid ? range.mid : 0) / basis) * 100, 0, 100);
    },

    tone(fillPercent) {
      if (fillPercent < 30) return 'low';
      if (fillPercent < 60) return 'mid';
      return 'normal';
    },

    /* Assist intensity (0-100) for the selected mode — real value if present. */
    assistLevel(config, modeId) {
      const mode = this.findMode(config, modeId);
      const real = Number(mode && mode.assist ? mode.assist : 0);
      if (real > 0) return real;
      const key = String(modeId || '').toLowerCase();
      return this.modeAssist[key] != null ? this.modeAssist[key] : 50;
    },

    /* Cruise speed (km/h) for the Top speed card. */
    topSpeed(config, modeId) {
      const assist = this.assistLevel(config, modeId);
      return 20 + (assist / 100) * 12;
    },

    rideHours(rangeMid, config, modeId) {
      const speed = this.topSpeed(config, modeId);
      if (!speed) return 0;
      return Number(rangeMid || 0) / speed;
    },

    efficiency(batteryWh, rangeMid) {
      const wh = Number(batteryWh || 0);
      const r = Number(rangeMid || 0);
      if (!wh || !r) return 0;
      return wh / r;
    },

    /* Estimated capacity retained after ~500 charge cycles, modulated by how
       hard the selected mode and conditions are on the pack. Higher assist +
       harsher environment = a touch more wear. Returns a % (e.g. 82 -> "82%"). */
    batteryWear(config, modeId, envFactors) {
      const assist = this.assistLevel(config, modeId);            // 0-100
      const envLoad = (envFactors || []).reduce((acc, f) => acc + (1 - Number(f || 1)), 0);
      const stress = (assist / 100) * 0.5 + clamp(envLoad, 0, 1) * 0.5; // 0-1
      const retained = 85 - stress * 10;                          // 75-85%
      return Math.round(clamp(retained, 70, 90));
    },
  };
})();
